import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { Base64 } from 'js-base64';

@Injectable({
  providedIn: 'root'
})
export class CatalogosService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/catalogos/Catalogos';
  }

  public getTiposUsuario() {
    // const headers = this.getHeaders();
    return this.httpClient.get(this.endpoint + '/ObtenerTipos');
   }
  
  public getRoles() {  
    // const headers = this.getHeaders();
    return this.httpClient.get(this.endpoint + '/ObtenerRols');
  }
  
  public getStations() {
    // const headers = this.getHeaders();
    return this.httpClient.get(this.endpoint + '/ObtenerEstaciones');
  }
}
